import * as Yup from 'yup';
import {DateRange, todayDateRange} from '~/lib/date';
import {ID} from '~/lib/model';

export interface IBalance {
    currentBalance?: number;
    changeBalance: number;
    actionType: 'add' | 'subtract';
    expectedBalance?: number;
    revenuePeriod: DateRange;
    comment?: string;
}

export const DateRangeSchema = Yup.object().shape<DateRange>({
    startDate: Yup.date().required(),
    endDate: Yup.date().required(),
});

export const BalanceSchema = Yup.object().shape<IBalance>({
    currentBalance: Yup.number().nullable(),
    changeBalance: Yup.number().required(),
    actionType: Yup.mixed().oneOf(['add', 'subtract']).required(),
    expectedBalance: Yup.number().nullable(),
    revenuePeriod: DateRangeSchema.required(),
    comment: Yup.string().required(),
});

export interface IFinanceTransaction {
    currentBalance: number;
    nextReleaseDate: string;
    scheduledPayout: number;
    interval?:
        | {
              start: string;
              end: string;
          }
        | Array<{
              start: string;
              end: string;
          }>
        | null;
    intervalInfo?: Array<{
        releaseId: string;
        status: string;
    }>;
    payments?: unknown[];
}

export interface ITransaction {
    accountId: ID,
    amount: number,
    revenuePeriod: {
        end: string;
        start: string;
    },
    comment: string
}

export const buildDefaultBalance = (transaction: IFinanceTransaction) => {
    const balanceValue = transaction ? parseFloat(transaction.currentBalance.toFixed(2)) : 0.0;
    return  {
        currentBalance: balanceValue,
        changeBalance: 0,
        actionType: 'add' as IBalance['actionType'],
        expectedBalance: balanceValue,
        revenuePeriod: todayDateRange(),
        comment: '',
    }
}
